module.exports = __webpack_public_path__ + "static/media/pf.8e525621.svg";